import { SuperBillControllerApi } from "../../services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "../../utils/utils";

/**
 *
 * @author Atish Bagate
 */
export const useInvoiceMailWithoutPaymentLink = () =>
  useMutationWithLoading(
    async ({
      superBillId,
      invoiceSentToPatient,
    }: {
      superBillId: string;
      invoiceSentToPatient?: boolean;
    }) =>
      new SuperBillControllerApi(
        getConfigObject()
      ).sendInvoiceWithoutPaymentLink(
        superBillId,
        invoiceSentToPatient,
        getXtenantId()
      )
  );
